import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import ProductCard from './ProductCard';
import { products } from '../data/mockData';

const FeaturedProducts = () => {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="text-amber-600 font-semibold text-sm tracking-wider uppercase">
            Our Collection
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-5">
            Featured Products
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Discover our most popular items, crafted with premium materials and designed for those who appreciate quality.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <Link to="/shop">
            <Button 
              variant="outline"
              className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white font-semibold px-8 py-5 text-base rounded-lg transition-all duration-300"
            >
              View All Products
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
